import { FormControl } from "@angular/forms";
import { Banks, Buckets } from "@core/enums";
import { SelectionOption } from "@core/models/shared";

export interface EmployerLeaveTypeDialog {
	leaveCategories: SelectionOption[];
}

export enum LeaveSchedules {
	Continuous = -1,
	Intermittent = -2
}

export interface LeaveTypeForm {
	name: FormControl<string>; //read only 
	leaveCategory: FormControl<number>;
	banks: FormControl<Banks[]>;
	buckets: FormControl<Buckets[]>;
	leaveSchedule: FormControl<LeaveSchedules>;
	leavesRequireAllBankHours: FormControl<boolean>;
	allowUse: FormControl<boolean>;
}

export interface LeaveTypePost {
	overrideUpdateConf: boolean;
	employerId: number;
	leaveTypeId: number; // nullable (used for edit)
	name: string;
	leaveCategory: number;
	banks: Banks[];
	buckets: Buckets[];
	leaveSchedule: LeaveSchedules;
	leavesRequireAllBankHours: boolean;
	allowUse: boolean;
}